import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import VideoSimpanPage from 'containers/pages/webManagement/videoSimpan/List'
import VideoSimpanForm from 'containers/pages/webManagement/videoSimpan/Form'

const VideoSimpan = ({
  currentUser, location, match,
}) => {
  if (location.pathname === '/web-management/video-simpan') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementvideo-simpan-read') > -1) {
      return <VideoSimpanPage location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('edit') || location.pathname.includes('add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementvideo-simpan-write') > -1) {
      return <VideoSimpanForm location={location} match={match} />
    }
    return <ForbiddenPage />
  }

  return ''
}

VideoSimpan.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default VideoSimpan
